import type { SyntheticEvent } from "react";
import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	PORTFOLIO_TAB_STORAGE_KEY,
	PortfolioTab,
} from "web_myplann/Portfolio/Types/portfolioTabs";

const TAB_PATHS: Record<PortfolioTab, string> = {
	[PortfolioTab.Portfolio]: Routing.Portfolio.PortfolioList.path(),
	[PortfolioTab.Documents]: Routing.Portfolio.DocumentsList.path(),
};

type UsePortfolioTabRoutingResult = {
	value: PortfolioTab;
	onChange: (event: SyntheticEvent, newValue: number) => void;
};

export const usePortfolioTabRouting = (): UsePortfolioTabRoutingResult => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const isResolving = pathname === Routing.Portfolio.PortfolioTabs.path();

	useLayoutEffect(() => {
		if (!isResolving) return;
		const stored = Number(localStorage.getItem(PORTFOLIO_TAB_STORAGE_KEY));
		navigate(
			stored === PortfolioTab.Documents
				? TAB_PATHS[PortfolioTab.Documents]
				: TAB_PATHS[PortfolioTab.Portfolio],
			{ replace: true },
		);
	}, [isResolving, navigate]);

	const value =
		pathname === Routing.Portfolio.DocumentsList.path()
			? PortfolioTab.Documents
			: PortfolioTab.Portfolio;

	const onChange = (_event: SyntheticEvent, newValue: number) => {
		if (newValue === value) return;
		localStorage.setItem(PORTFOLIO_TAB_STORAGE_KEY, String(newValue));
		navigate(TAB_PATHS[newValue as PortfolioTab], { replace: true });
	};

	return { value, onChange };
};
